import Model from '@/shared/models/CancellationRequisition'

export default class CancellationRequisition extends Model {}
